import { type Common } from './common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async verify(
    captchaToken: string
  ): Promise<{ status: number; message?: string | undefined } | { success: boolean }> {
    const url = this.common.constructPath('/patient-previsit/captcha/verify');
    return await this.common.postJSON(url, { captchaToken }, 'POST', undefined, true);
  }
}
